module.exports = __webpack_public_path__ + "fonts/font.08c6dbc.woff";